import React, { useEffect, useState } from 'react';
import axios from "axios";
import { useAuth0 } from "../hooks/react-auth0-spa";

import { API_URL } from "../constants/constants";
import MaterialTable from 'material-table';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { CircularProgress } from '@material-ui/core';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';

const Cuenta = () => {
    const [loading, setLoading] = useState(false)
    const { getTokenSilently, user } = useAuth0();
    // console.log(user);
    const [data,setData]=useState();
    useEffect(() => {
        const fetchStatistics = async () => {
          setLoading(true);
          try {
            const t = await getTokenSilently();
            const r = await axios.get(API_URL + `/cuenta/${user.sub}`, {
              headers: {
                Authorization: `Bearer ${t}`
              }
            });
            // console.log(r.data);
            setData(r.data);
          } catch (error) {
            // console.log(error);
            // setIsError(true);
          }
          setLoading(false);
        };
     fetchStatistics();
        // eslint-disable-next-line
      }, [user]);
    return (loading?<CircularProgress/>:
      <MaterialTable
        title="Estado de Cuenta"
        columns={[
            {title:"Descripción",field:'title'},
            {field:'gasto',render: rowData=>rowData.gasto?<ArrowDownwardIcon style={{color:red[500]}} />:<ArrowUpwardIcon style={{color:green[500]}} />},
            {title:"Cantidad",field:'monto'},
            {title:"Saldo Anterior",field:'before'},
            {title:"Saldo Posterior",field:'after'},
            {title:"Fecha",field:'fecha'}
        ]}
        data={data}
    />);
}
 
export default Cuenta;